import { useAuthStore } from "@/stores/useAuth";
import { DeviceType } from "@/codegen/graphql/generated/graphql";
import {
  hasPremiumGracePeriod,
  setPremiumGracePeriod,
} from "@/lib/premiumGracePeriod";

const usePremium = () => {
  const storePremium = useAuthStore((s) => !!s.currentUser?.premium?.productId);

  // Keep the user premium during the Stripe webhook delay window — see
  // `premiumGracePeriod.ts` for the rationale.
  const isPremium = storePremium || hasPremiumGracePeriod();

  const grantPremiumAccess = () => {
    const currentUser = useAuthStore.getState().currentUser;
    if (currentUser) {
      // Fake premium access until backend updates with webhook event
      useAuthStore.setState({
        currentUser: {
          ...currentUser,
          premium: { productId: "premium", platform: DeviceType.Web },
        },
      });
      setPremiumGracePeriod();
    }
  };

  return {
    isPremiumUser: isPremium,
    grantPremiumAccess,
  };
};

export default usePremium;
